import { render } from "./MainComponent.vue?vue&type=template&id=4920c1ec&ts=true"
import script from "./MainComponent.vue?vue&type=script&lang=ts"
export * from "./MainComponent.vue?vue&type=script&lang=ts"

import "./MainComponent.vue?vue&type=style&index=0&id=4920c1ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__